const setNewsFeedId = ({ commit }, id) => {
  commit("setNewsFeedId", id);
};

export { setNewsFeedId };
